<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Question Form</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="px-3 py-4">
  <form #f="ngForm" (ngSubmit)="onSubmit(f)">

    <div class="row">
      <div class="col-md-9">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Question</mat-label>
          <input
            matInput
            placeholder="Question"
            [(ngModel)]="question_data.question"
            name="question"
            type="text"
            #question
            required />
          <mat-error *ngIf="!question.valid">Please enter a question.</mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-3">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Status</mat-label>
          <mat-select
            placeholder="Status"
            [(ngModel)]="question_data.status"
            name="status"
            required>
            <mat-option value="Draft">Draft</mat-option>
            <mat-option value="Published">Published</mat-option>
          </mat-select>
          <mat-error *ngIf="!question_data.status">Please select the status of this section.</mat-error>
        </mat-form-field>
      </div>
    </div>

    <h6 class="card-title">Answers</h6>

    <div *ngFor="let control of question_data.answers; let i = index">
      <div class="row mt-4">
        <div class="col-md-8">
          <mat-form-field class="full-width mb-0" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Answer {{ i + 1 }}</mat-label>
            <input
              matInput
              placeholder="Answer {{ i + 1 }}"
              name="answer-text-{{i}}"
              [(ngModel)]="question_data.answers[i].answer_text"
              type="text"
              required />
            <mat-error *ngIf="!question_data.answers[i].answer_text">Please enter the answer.</mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-4">
          <div class="row">
            <div class="col-6 d-flex align-items-center">
              <mat-slide-toggle
                [(ngModel)]="question_data.answers[i].answer_value"
                name="answer-value-{{i}}">
                {{question_data.answers[i].answer_value ? 'Yes' : 'No'}}
              </mat-slide-toggle>
            </div>
            <div class="col-6 d-flex justify-content-end justify-content-md-start">
              <button
                type="button"
                color="warn"
                mat-icon-button
                [disabled]="question_data.answers.length === 1"
                class="delete-answer dialog-remove-button m-1"
                (click)="onRemoveAnswer(i)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </form>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="px-3 py-2">
  <button
    mat-raised-button
    [disabled]="!f.valid"
    color="primary"
    class="my-2 ml-1 mr-2"
    (click)="onSubmit(f)">
    <mat-icon>save</mat-icon>
    Save
  </button>
  <button
    mat-raised-button
    color="secondary"
    class="my-2 ml-1 mr-2"
    (click)="onAddAnswer()">
    <mat-icon>add</mat-icon>
    Add Answer
  </button>
</mat-dialog-actions>
